import React from 'react';
import {PropTypes} from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {fetchPipeline, exportPipeline} from '../../actions/pipelineActions';
import {PIPELINE_HEADERS, PIPELINE_VALUES, PIPELINE_VALUES_FOR_DATA_LABELS} from '../../constants/tableHeaders';
import utils from '../../lib/utils';
import {
  trackPageView,
  trackSearch,
  trackUserClick,
  trackUserInput,
  trackUserAttribute
} from '@forwardfinancing/analytics-frontend-library';
import PipelineFilter from './PipelineFilter';
import PipelinePortfolioBase from '../common/PipelinePortfolioBase/PipelinePortfolioBase';

const didInitiateSearch = query => trackSearch({
  attribute: 'Pipeline',
  data: {
    searchParam: query.q,
    startDate: query.start_date,
    endDate: query.end_date,
    newOrRenewal: query.new_or_renewal,
    sort: query.sort,
    order: query.order,
    stageName: query.stage_name,
  },
  page: query.page
});
const didExport = () => {
  trackUserClick({ attribute: 'export' });
  trackUserAttribute({ attribute: 'export' });
};
const didSort = query => trackUserInput({ label: 'Sort', Page: 'pipeline', 'Sort By': query.sort, Order: query.order });

const delegate = { didInitiateSearch, didExport, didSort };

export class PipelinePage extends React.Component {
  componentDidMount() {
    trackPageView('Pipeline');
  }

  render() {
    const tableInfo = {
      headers: PIPELINE_HEADERS,
      values: PIPELINE_VALUES,
      data: this.props.pipeline,
      totalPages: this.props.pipelinePagination.totalPages,
      currentPage: this.props.pipelinePagination.currentPage,
      dataLabels: PIPELINE_VALUES_FOR_DATA_LABELS,
      isSearchError: this.props.pipelineError,
      actionCellRenderer: rowData => utils.opportunityActionCellData(rowData),
      isAdmin: this.props.isAdmin,
      hasSpinner: this.props.hasSpinner
    };


    return (
      <PipelinePortfolioBase
        headerText="Pipeline"
        fetchFilter={this.props.fetchFilter}
        exportFilter={this.props.exportFilter}
        delegate={delegate}
        FilterComponent={PipelineFilter}
        tableInfo={tableInfo}
        selectedPartner={this.props.selectedPartner}
        hasSpinner={this.props.hasSpinner}
      />
    );
  }
}

// istanbul ignore next
function mapStateToProps(state){
  return {
    pipeline: state.pipeline,
    pipelinePagination: state.pipelinePagination,
    pipelineError: state.pipelineError,
    selectedPartner: state.partner.selected,
    isAdmin: state.user && utils.isAdmin(state.user.role),
    hasSpinner: true
  };
}

// istanbul ignore next
function mapDispatchToProps(dispatch){
  return {
    fetchFilter: bindActionCreators(fetchPipeline, dispatch),
    exportFilter: bindActionCreators(exportPipeline, dispatch),
  };
}

PipelinePage.propTypes = {
  pipeline: PropTypes.array.isRequired,
  pipelinePagination: PropTypes.object.isRequired,
  pipelineError: PropTypes.bool.isRequired,
  selectedPartner: PropTypes.object,
  isAdmin: PropTypes.bool,
  fetchFilter: PropTypes.func.isRequired,
  exportFilter: PropTypes.func.isRequired,
  hasSpinner: PropTypes.bool
};

export default connect(mapStateToProps, mapDispatchToProps)(PipelinePage);
